import axios from "./httpService";

export default {
  sendTokenToServer: token => axios.post(`/v3/web`, { token, fcm: true }),
  deleteTokenFromServer: token => axios.delete(`/v3/web`, { data: { token } })
};
